import { render, staticRenderFns } from "./ModalCriarEditarEspecialidadeProcedimento.vue?vue&type=template&id=2be711b6&scoped=true"
import script from "./ModalCriarEditarEspecialidadeProcedimento.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarEspecialidadeProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarEspecialidadeProcedimento.vue?vue&type=style&index=0&id=2be711b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be711b6",
  null
  
)

export default component.exports